import APIController from "./APIController";
import SyncHelper from '../Helper/SyncHelper';
import {useWebSocket} from "../Context/WebSocketContext";

const Discount =() =>{
    //Requesthelper
    const {basicRequest, jsonRequest, getWorkspaceId} = APIController()
    const {readOffline} = SyncHelper()
    const {isOnline} = useWebSocket()

    const fetchDiscount = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return []; 
        if (isOnline === false) return readOffline('discounts');
        const data = await jsonRequest(`/${workspaceId}/discount`);
        return data;
    };

    const createDiscount = async (discountDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/discount/new`, "POST", discountDTO);
        return data;
    };

    const deleteDiscount = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/discount/${id}`, "DELETE");
        return data;
    };
    return{
        fetchDiscount,
        createDiscount,
        deleteDiscount
    }
}
export default Discount;